import { render, staticRenderFns } from "./CHomicides.vue?vue&type=template&id=45e80d79"
import script from "./CHomicides.vue?vue&type=script&lang=js"
export * from "./CHomicides.vue?vue&type=script&lang=js"
import style0 from "./CHomicides.vue?vue&type=style&index=0&id=45e80d79&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports